import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../../../api/api";

export default function Documents() {
  const { id } = useParams();
  const [retreat, setRetreat] = useState({});

  useEffect(() => {
    getData(`/retreats/${id}`)
      .then((e) => {
        console.log(e.data);
        setRetreat(e.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">List of documents:</h1>
      <div className="grid gap-4">
        {retreat?.retreatDocuments?.map((data) => (
          <div
            key={data.id}
            className="p-4 border rounded-lg hover:shadow-lg transition-shadow duration-200"
          >
            <a
              href={data.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              <h2 className="text-xl font-semibold">{data.fileName}</h2>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
